import React, { useEffect } from 'react';
import { Modal, Form, TimePicker, InputNumber, Button, notification } from 'antd';
import dayjs from 'dayjs';
import { useAddShiftSlot, useUpdateShiftSlot } from '../../../hooks/useShifts';

const SlotFormModal = ({ visible, onCancel, dayId, editingSlot }) => {
    const [form] = Form.useForm();
    const addSlotMutation = useAddShiftSlot();
    const updateSlotMutation = useUpdateShiftSlot();

    useEffect(() => {
        if (visible) {
            if (editingSlot) {
                form.setFieldsValue({
                    startTime: editingSlot.startTime ? dayjs(editingSlot.startTime, 'HH:mm:ss') : null,
                    endTime: editingSlot.endTime ? dayjs(editingSlot.endTime, 'HH:mm:ss') : null,
                    maxPatients: editingSlot.maxPatients
                });
            } else {
                form.resetFields();
            }
        }
    }, [visible, editingSlot, form]);

    const formatTimeString = (time) => time ? time.format('HH:mm') : null;

    const handleSubmit = async () => {
        console.log(editingSlot,"ة");
        
        try {
            const values = await form.validateFields();
            
            if (editingSlot) {
                const idToUpdate = editingSlot.hourId || editingSlot.id;
                
                await updateSlotMutation.mutateAsync({
                    slotId: idToUpdate,
                    startTime: formatTimeString(values.startTime),
                    endTime: formatTimeString(values.endTime),
                    maxPatients: values.maxPatients
                });
                notification.success({ message: 'Slot updated successfully' });
            } else {
                await addSlotMutation.mutateAsync({
                    shiftId: dayId,
                    startTime: formatTimeString(values.startTime),
                    endTime: formatTimeString(values.endTime),
                    maxPatients: values.maxPatients
                });
                notification.success({ message: 'Slot added successfully' });
            }

            onCancel();
        } catch (err) {
            console.error('Submission error:', err);
            notification.error({ 
                message: 'Error', 
                description: err.response?.data[0] || 'Action failed' 
            });
        }
    };

    const isLoading = addSlotMutation.isLoading || updateSlotMutation.isLoading;

    return (
        <Modal
            title={editingSlot ? 'Edit Time Slot' : 'Add Time Slot'}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel} disabled={isLoading}>Cancel</Button>,
                <Button
                    key="save"
                    type="primary"
                    onClick={handleSubmit}
                    loading={isLoading}
                    style={{ backgroundColor: '#298d9f', borderColor: '#298d9f' }}
                >
                    {editingSlot ? 'Update' : 'Add'} Slot
                </Button>
            ]}
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <div className="flex gap-4">
                    <Form.Item
                        name="startTime"
                        label="Start Time"
                        rules={[{ required: true, message: "Required" }]}
                        className="flex-1"
                    >
                        <TimePicker className="w-full" format="hh:mm A" minuteStep={15} showSecond={false} />
                    </Form.Item>

                    <Form.Item
                        name="endTime"
                        label="End Time"
                        dependencies={['startTime']}
                        rules={[
                            { required: true, message: "Required" },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || !getFieldValue('startTime')) return Promise.resolve();
                                    return value.isAfter(getFieldValue('startTime')) 
                                        ? Promise.resolve() 
                                        : Promise.reject(new Error('Must be after start'));
                                },
                            }),
                        ]}
                        className="flex-1"
                    >
                        <TimePicker className="w-full" format="hh:mm A" minuteStep={15} showSecond={false} />
                    </Form.Item>
                </div>

                <Form.Item name="maxPatients" label="Maximum Patients" initialValue={1}>
                    <InputNumber className="w-full" min={0} max={100} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default SlotFormModal;